import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useRerender from '../../Common/components/hooks/useRerender';
import Table, { createColumnHelper } from '../../Common/components/Table';
import useDeviceKeys from './hooks/useDeviceKeys';
import moment from 'moment-timezone';
import useUserOrg from '../../Authentication/components/hooks/useUserOrg';
import GroupDeviceKeyActions from './GroupDeviceKeyActions';

const columnHelper = createColumnHelper<DeviceKey>();

export default function GroupDeviceKeys() {
    const { groupId } = useParams();
    const { orgId } = useUserOrg();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [deviceKeys, setDeviceKeys] = useState<DeviceKey[]>([]);
    const [group, setGroup] = useState<DeviceGroup | null>(null);
    const { getDeviceKeys } = useDeviceKeys(orgId);

    const { render, renderCount } = useRerender();

    const onDelete = () => {
        render();
    };
    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            try {
                const deviceKeys = await getDeviceKeys(+(groupId || 0));
                setDeviceKeys(deviceKeys.keys);
                setGroup(deviceKeys.group);
            } catch (e) {
                console.error(e);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        load();

        return () => {
            isMounted = false;
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [renderCount]);

    const columnDefinitions = [
        columnHelper.accessor('name', {
            id: 'name',
            header: () => <span>name</span>,
            cell: (info) => <span>{info.getValue()}</span>,
        }),
        columnHelper.accessor('keyId', {
            id: 'keyId',
            header: () => <span>keyId</span>,
            cell: (info) => <span>{info.getValue()}</span>,
        }),
        columnHelper.accessor('lastUsed', {
            id: 'lastUsed',
            header: () => <span>last seen</span>,
            cell: (info) => (
                <span>
                    {info.getValue()
                        ? `${moment(info.getValue()).toNow(true)} ago`
                        : ''}
                </span>
            ),
        }),
        columnHelper.display({
            id: 'actions',
            cell: (props: { row: any }) => (
                <GroupDeviceKeyActions
                    orgId={orgId}
                    row={props.row}
                    groupId={groupId ? +groupId : 0}
                    onDelete={onDelete}
                />
            ),
        }),
    ];

    if (isLoading) {
        return <div>loading</div>;
    }

    return (
        <div>
            <h1>{group?.name} device keys</h1>
            {/*<div className="row">
                <span className="Primary-button">+ assign device</span>
    </div>*/}
            <br />
            <Table data={deviceKeys} columns={columnDefinitions} />
        </div>
    );
}
